export const sharedAttrs = {
  internalType: {
    default: null,

    parseHtml(element: HTMLElement) {
      return element.getAttribute('data-internal-type')
    },

    renderHTML(attrs: Record<string, any>) {
      return attrs['internalType'] ? { 'data-internal-type': attrs['internalType'] } : {}
    },
  },
}
